import { Validators } from '@angular/forms';
import { DateUtils } from 'src/app/utils/date.utils';
import { tenorFormatValidator } from '../../validators/tenor-format.validator';
import { HurdlesAndSpreads, TableCols } from '../interfaces/static-data';

export const HURDLES_AND_SPREADS: TableCols[] = [
  {
    key: 'currency',
    displayValue: 'Currency',
    type: 'select',
    validators: [Validators.required],
  },
  {
    key: 'tenor',
    displayValue: 'Tenor',
    type: 'select',
    items: [
      {
        id: '1Y',
        displayValue: '1Y',
      },
      {
        id: '2Y',
        displayValue: '2Y',
      },
      {
        id: '3Y',
        displayValue: '3Y',
      },
      {
        id: '5Y',
        displayValue: '5Y',
      },
      {
        id: '6Y',
        displayValue: '6Y',
      },
      {
        id: '7Y',
        displayValue: '7Y',
      },
      {
        id: '8Y',
        displayValue: '8Y',
      },
      {
        id: '9Y',
        displayValue: '9Y',
      },
      {
        id: '10Y',
        displayValue: '10Y',
      },
    ],
    selectOptions: {
      allowFreeText: true,
      searchable: true,
    },
    validators: [Validators.required, tenorFormatValidator()],
  },
  {
    key: 'marketRate',
    displayValue: 'Market Rate',
    type: 'input',
  },
  {
    key: 'spread',
    displayValue: 'Spread',
    type: 'input',
    validators: [Validators.required],
  },
  {
    key: 'asOfDate',
    displayValue: 'As of Date',
    type: 'date',
    validators: [Validators.required],
    format: (hurdle: HurdlesAndSpreads) => {
      return hurdle.asOfDate ? DateUtils.convertDateKindToString(hurdle.asOfDate, 'DD-MM-YYYY') : '-';
    }
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
